import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MenuAreaDto } from '@core/services/api-clients';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MenuItemComponent } from '../../shared/menu-item/menu-item.component';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-main-menu-area-selector',
    templateUrl: './main-menu-area-selector.component.html',
    styleUrls: ['./main-menu-area-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        MatSelect,
        ReactiveFormsModule,
        FormsModule,
        MatSelectTrigger,
        MenuItemComponent,
        MatOption,
    ]
})
export class MainMenuAreaSelectorComponent {
  readonly menuAreas = input<MenuAreaDto[]>([]);
  readonly selectedMenuArea = input<MenuAreaDto>(undefined);
  readonly isWide = input<boolean>(false);
  readonly areaChanged = output<string>();
}
